import type { Point } from '../types/point.js';
import type { RelativeAbsolutePosition } from '../types/pointer-events.js';

export interface ChartBounds {
  left: number;
  top: number;
  width: number;
  height: number;
}

export interface TooltipOffset {
  x: number;
  y: number;
}

/**
 * Calculates the adjusted tooltip position based on chart bounds, position data, and optional offset.
 *
 * @returns The adjusted absolute position for the tooltip, or undefined if position data is unavailable
 */
export const calculateAdjustedTooltipPosition = (
  bounds: ChartBounds | undefined,
  position: RelativeAbsolutePosition | undefined,
  offset: TooltipOffset = { x: 0, y: 0 },
): Point | undefined => {
  if (bounds && position?.relative) {
    return {
      x: bounds.left + position.relative.x + offset.x,
      y: bounds.top + position.relative.y + offset.y,
    };
  }

  if (position?.absolute) {
    return {
      x: position.absolute.x + offset.x,
      y: position.absolute.y + offset.y,
    };
  }

  return undefined;
};
